import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  ICreateWithdrawalPayload,
  IWithdrawalReduceDriftExportPayload,
  IWithdrawalInstruction,
  IWithdrawalInstructionResponse,
  IRegularWithdrawalPlan, IRegularWithdrawalResponse
} from "src/app/models/withdrawals";
import { BaseHttpService } from "./base.http.service";
import { AppConfig } from 'src/app/app.config';
import { BehaviorSubject, Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { IEnvironmentConfig } from "src/app/models/environmentConfig";

@Injectable()
export class WithdrawalsService extends BaseHttpService {
    constructor(
        private http: HttpClient, private appConfig: AppConfig) {
        super();
    }

    get envSettings(): IEnvironmentConfig {
        return this.appConfig.getEnvironmentConfig();
    }

    public createNewCashWithdrawal(body: ICreateWithdrawalPayload) {
        const jsonBody = JSON.stringify(body.withdrawal);
        const url = `${this.envSettings.webApiUrl}portfolio/${body.portfolioId}/withdrawals`;
        return this.http.post(url, jsonBody, {
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public getRegularWithdrawalPlans(portfolioIds: number[]): Observable<IRegularWithdrawalResponse>{
      const url = new URL(`${this.envSettings.webApiUrl}portfolios/instructions/withdrawals/regular`);

      if(!!!portfolioIds || portfolioIds.length === 0){
        let data = {
          loading: false,
          data: [],
          error: false
        } as IRegularWithdrawalResponse;
        return of(data);
      }

      // Add portfolioIds to the query string.
      portfolioIds.forEach(portfolioId => {
        url.searchParams.append('portfolioIds', portfolioId.toString());
      });


      return this.http.get(url.toString(), {
          observe: 'body',
          responseType: 'json',
          headers: this.getHttpHeaders()
      }).pipe(
        map((data: IRegularWithdrawalPlan[]) => {
          return {
            loading: false,
            data: data,
            error: false
          } as IRegularWithdrawalResponse
        }),
        catchError(() => {
          return of({
            loading: false,
            data: [],
            error: true
          } as IRegularWithdrawalResponse)
        }))
    }

    public approveWithdrawalInstruction(portfolioId: number, instructionId: number) : Observable<any>{
        let baseUrl = new URL(`${this.envSettings.webApiUrl}portfolio/${portfolioId}/instructions/withdrawals/${instructionId}/approve`);

        return this.http.post(
            baseUrl.toString(),
            {},
            {
                observe: 'body',
                responseType: 'json',
                headers: this.getHttpHeaders()
            }
        );
    }

    // Helper method to retrieve the body of an blob error response using FileReader.
    private parseErrorBlob(errorResponse: HttpErrorResponse): Observable<any> {
      const reader: FileReader = new FileReader();

      const obs = new Observable((observer: any) => {
        // Parse the error after the reader has loaded the body content.
        reader.onloadend = (e) => {
          observer.error(JSON.parse(reader.result as string));
          observer.complete();
        }

        reader.readAsText(errorResponse.error);
        return obs;
      });

      return obs;
    }

  /**
     * Retrieves withdrawal instructions for the given portfolios and outputs the result to a behaviour subject.
     */
    public getWithdrawalInstructions(portfolioIds: number[]): Observable<IWithdrawalInstructionResponse> {
        var baseUrl = new URL(`${this.envSettings.webApiUrl}portfolios/withdrawals?`);

        if(!!!portfolioIds || portfolioIds.length === 0){
            let data = {
                loading: false,
                data: [],
                error: false
            } as IWithdrawalInstructionResponse;
            return of(data);
        }

        portfolioIds.forEach(portfolioId => {
            baseUrl.searchParams.append('portfolioIds', portfolioId.toString());
        });

        return this.http.get(
            baseUrl.toString(),
            {
                observe: 'body',
                responseType: 'json',
                headers: this.getHttpHeaders()
            }
        )
        .pipe(
            map((data: IWithdrawalInstruction[]) => {
                return {
                    loading: false,
                    data: data,
                    error: false
                } as IWithdrawalInstructionResponse
            }),
            catchError(() => {
                return of({
                    loading: false,
                    data: [],
                    error: true
                } as IWithdrawalInstructionResponse)
            }));
    }

  approveRegularWithdrawal(portfolioId: number, regularWithdrawalId: number) {
    let baseUrl = new URL(`${this.envSettings.webApiUrl}portfolio/${portfolioId}/instructions/withdrawals/regular/${regularWithdrawalId}/approve`);

    return this.http.post(
      baseUrl.toString(),
      {},
      {
        observe: 'body',
        responseType: 'json',
        headers: this.getHttpHeaders()
      }
    );
  }
}